import {all, call, fork, put, takeEvery} from "redux-saga/effects";
import {fetchBuzzSuccess, fetchBuzzError, addBuzzSuccess, addBuzzError, updateBuzzSuccess, updateBuzzError, deleteBuzzSuccess, deleteBuzzError} from '../actions/Buzz';
import { getDocs, addDoc, updateDoc, deleteDoc } from 'firebase/services/buzz';
import {FETCH_BUZZ, ADD_BUZZ, UPDATE_BUZZ, DELETE_BUZZ} from 'constants/ActionTypes';

function* fetchBuzzRequest({ params }) {
  try {
    const fetchedBuzzList = yield call(getDocs, { filter: params && params.filter });
    yield put(fetchBuzzSuccess(fetchedBuzzList));
  } catch (error) {
    console.log(error);
    yield put(fetchBuzzError(error));
  }
}

function* addBuzzRequest({ payload: { params } }) {
  try {
    const requests = params.map(param => call(addDoc, {data: param}));
    const result = yield all(requests);
    yield put(addBuzzSuccess(result));
  } catch (error) {
    console.log(error);
    yield put(addBuzzError(error));
  }
}

function* updateBuzzRequest({ payload: { params } }) {
  try {
    const result = yield call(updateDoc, {data: params});
    yield put(updateBuzzSuccess(result));
  } catch (error) {
    console.log(error);
    yield put(updateBuzzError(error));
  }
}

function* deleteBuzzRequest({ payload: { params } }) {
  try {
    yield call(deleteDoc, {id: params});
    yield put(deleteBuzzSuccess({ id: params }));
  } catch (error) {
    console.log(error);
    yield put(deleteBuzzError(error));
  }
}

export function* fetchBuzz() {
  yield takeEvery(FETCH_BUZZ, fetchBuzzRequest);
}

export function* addBuzz() {
  yield takeEvery(ADD_BUZZ, addBuzzRequest);
}

export function* updateBuzz() {
  yield takeEvery(UPDATE_BUZZ, updateBuzzRequest);
}

export function* deleteBuzz() {
  yield takeEvery(DELETE_BUZZ, deleteBuzzRequest);
}

export default function* rootSaga() {
  yield all([fork(fetchBuzz), fork(addBuzz), fork(updateBuzz), fork(deleteBuzz)]);
}
